const Steps = ({
  current,
  total,
  title,
  description,
  infoMsg,
  wrapperClassNames = "pb-4",
}) => {
  return (
    <div className={`${wrapperClassNames} text-center`} id="Steps">
      <div className="flex-between-center flex-column">
        {current && (
          <div className="stepCount">
            STEP {current} OF {total}
          </div>
        )}
        <div className="title mb-3">{title}</div>
        {typeof description === "object" ? (
          <div className="description" dangerouslySetInnerHTML={description} />
        ) : (
          <div className="description">{description}</div>
        )}
        {infoMsg && <div className="info-msg py-3 px-5 mt-3">{infoMsg}</div>}
      </div>
    </div>
  );
};

export default Steps;
